<script lang="ts">
  import * as AlertDialog from '$lib/components/ui/alert-dialog';
  import { Button } from '$lib/components/ui/button';

  // Shared by MessageBubble.svelte and CommentItem.svelte -- the delete-confirmation dialog was
  // identical apart from the entity/container noun used in its copy.
  export let open: boolean;
  export let entityNoun: 'message' | 'comment';
  export let containerNoun: 'conversation' | 'thread';
  export let onConfirm: () => void;
</script>

<AlertDialog.Root portal="#shadcn-ui-dialog-target" bind:open>
  <AlertDialog.Content>
    <AlertDialog.Header>
      <AlertDialog.Title>Delete this {entityNoun}?</AlertDialog.Title>
      <AlertDialog.Description>
        This can't be undone. Anyone {containerNoun === 'conversation' ? 'in the conversation' : 'with access to this thread'} will see that it was deleted.
      </AlertDialog.Description>
    </AlertDialog.Header>
    <AlertDialog.Footer>
      <AlertDialog.Cancel>Cancel</AlertDialog.Cancel>
      <AlertDialog.Action asChild let:builder>
        <Button builders={[builder]} variant="destructive" on:click={onConfirm}>Delete</Button>
      </AlertDialog.Action>
    </AlertDialog.Footer>
  </AlertDialog.Content>
</AlertDialog.Root>
